import angular from 'angular';
import '../core.module';

const OPTIONS_PAGE_SIZE = 100;

class UsersApiService {
  constructor($http, API_BASE_URL) {
    this.$http = $http;
    this.API_BASE_URL = API_BASE_URL;
  }

  listOptions() {
    return this.$http
      .get(`${this.API_BASE_URL}/users`, { params: { page: 1, pageSize: OPTIONS_PAGE_SIZE } })
      .then((response) =>
        response.data.items.map((user) => ({ value: user.id, label: user.name }))
      );
  }
}

UsersApiService.$inject = ['$http', 'API_BASE_URL'];

angular.module('app.core').service('UsersApiService', UsersApiService);

export default UsersApiService;
